<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('materials.Materials')"
          :description="$t('materials.FromHereYouCanControlTheMaterials')"
          :explanationPath="path + '/explaination'"
        />
        <indexTable
          :searchText="$t('materials.SearchForRawMaterial')"
          :emptyTableText="$t('materials.ThereAreNoMaterials')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('products_add')"
          :cloumns="[
            {
              column: 'name',
              title: $t('materials.TheNameOfTheMaterial'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'section_id',
              title: $t('products.category'),
              type: 'link',
              to: 'section',
              sort: true,
              link: false,
              icon: 'folders'
            },
            {
              column: 'cost',
              title: $t('materials.Cost'),
              type: 'text',
              sort: true,
              icon: 'dollar-sign'
            },
            {
              column: 'options',
              title: $t('products.settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('customers_edit')
                },
                {
                  name: 'printBarcode',
                  title: $t('materials.BarcodePrint'),
                  icon: 'barcode-alt'
                },
                {
                  name: 'delete',
                  role: $checkRole('customers_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
    <importForm v-if="importShow" />
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
import importForm from './components/importForm.vue'

export default {
  data() {
    return {
      path: '/materials',
      importShow: false
    }
  },
  methods: {
    importForm() {
      this.importShow = true
    }
  },
  components: {
    indexHeader,
    indexTable,
    importForm
  }
}
</script>
